// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c6d554e0","839":"3cef8dda"}[chunkId] + ".chunk.js";
};